"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Button = require("./Button");
var _styles = require("@material-ui/styles");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _clsx10 = _interopRequireDefault(require("clsx"));
var _IconButton = require("./IconButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dialogTitleRoot: {
      // padding uxui프로젝트 디자인 반영
      padding: "24px 24px 0 24px",
      minHeight: 46
    },
    longHeaderRoot: _defineProperty({
      // padding uxui프로젝트 디자인 반영
      padding: "24px 24px 0 24px",
      maxWidth: 524
    }, theme.breakpoints.up("sm"), {
      padding: "16px 20px 0 20px"
    }),
    dialogTitleFull: _objectSpread({}, theme.direction === "rtl" ? {
      padding: "13px 15px 10px 13px"
    } : {
      padding: "13px 13px 10px 15px"
    }),
    dialogTitleIcon: {
      display: "flex",
      alignItems: "center",
      padding: "13px 13px 0"
    },
    dialogTitleClose: _objectSpread({}, theme.direction === "rtl" ? {
      padding: "13px 24px 0 44px"
    } : {
      padding: "13px 44px 0 24px"
    }),
    dialogContentIcon: _objectSpread({}, theme.direction === "rtl" ? {
      paddingRight: 48
    } : {
      paddingLeft: 48
    }),
    headingTextIcon: _objectSpread({}, theme.direction === "rtl" ? {
      paddingRight: 8
    } : {
      paddingLeft: 8
    }),
    longHeaderText: {
      lineHeight: "21px !important"
    },
    noPadding: {
      padding: "0!important"
    },
    mg0: {
      margin: 0
    },
    // mg24: {
    //   "&:first-child": {
    //     // padding: "20px 24px 24px",
    //     padding: theme.spacing(3),
    //   },
    // },
    contentPadding: _defineProperty({
      padding: "15px 24px 32px"
    }, theme.breakpoints.up("sm"), {
      padding: "17px 24px 32px"
    }),
    longHeaderContentPadding: _defineProperty({
      padding: "15px 24px 31px"
    }, theme.breakpoints.up("sm"), {
      padding: "15px 24px"
    }),
    longHeaderNoContentPadding: _defineProperty({
      padding: "16px 24px"
    }, theme.breakpoints.up("sm"), {
      padding: "17px 24px"
    }),
    contentFullSize: {
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      padding: theme.spacing(2.25, 2.875),
      display: "flex"
    },
    contentFullNoBoder: {
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      padding: " 16px 16px 24px",
      flex: 0
    },
    close: {
      width: 30,
      height: 30,
      position: "absolute",
      // uxui프로젝트 디자인 반영
      top: "21px",
      padding: 0,
      color: _pittaModules.LightColors.primary["1"],
      zIndex: 1010
    },
    closeRight: _objectSpread({}, theme.direction === "rtl" ? {
      left: "21px",
      marginRight: 6
    } : {
      right: "21px",
      marginLeft: 6
    }),
    closeLeft: _objectSpread({}, theme.direction === "rtl" ? {
      right: "21px",
      marginLeft: 6
    } : {
      left: "21px",
      marginRight: 6
    }),
    closeLongHeader: _objectSpread({
      // uxui프로젝트 디자인 반영
      top: "13px"
    }, theme.direction === "rtl" ? {
      left: "17px",
      marginRight: 6
    } : {
      right: "17px",
      marginLeft: 6
    }),
    headerBtn: {
      position: "absolute",
      top: "13px",
      padding: 0,
      display: "flex",
      flexDirection: "row",
      right: "13px",
      marginLeft: 6
    },
    btnCenterWrap: {
      display: "flex",
      "&:not(:first-child)": _objectSpread({}, theme.direction === "rtl" ? {
        marginRight: 0
      } : {
        marginLeft: 0
      })
    },
    buttonPadding: {
      padding: "0px 24px 24px"
    },
    longHeaderbtnPadding: _defineProperty({
      padding: "0px 16px 24px"
    }, theme.breakpoints.up("sm"), {
      padding: "0px 24px 24px"
    }),
    btnFullSize: {
      padding: "15.5px 16px"
    },
    btnFullCenter: {
      padding: theme.spacing(1.125, 3, 1.5)
    },
    btnCenter: {
      justifyContent: "center"
    },
    rbutton: _defineProperty({
      // uxui프로젝트 디자인 반영
      borderRadius: 10,
      minWidth: "143.5px",
      minHeight: 48
    }, theme.breakpoints.up("sm"), {
      minWidth: "139.5px"
    }),
    longHeaderRbutton: _defineProperty({
      // uxui프로젝트 디자인 반영
      minWidth: "151.5px"
    }, theme.breakpoints.up("sm"), {
      minWidth: "139.5px"
    }),
    lbutton: _objectSpread(_objectSpread({
      // uxui프로젝트 디자인 반영
      borderRadius: 10,
      minWidth: "143.5px",
      minHeight: 48
    }, theme.direction === "rtl" ? {
      marginLeft: theme.spacing(1)
    } : {
      marginRight: theme.spacing(1)
    }), {}, _defineProperty({}, theme.breakpoints.up("sm"), _objectSpread({
      minWidth: "139.5px"
    }, theme.direction === "rtl" ? {
      marginLeft: theme.spacing(2)
    } : {
      marginRight: theme.spacing(2)
    }))),
    longHeaderLbutton: _defineProperty({
      // uxui프로젝트 디자인 반영
      minWidth: "151.5px"
    }, theme.breakpoints.up("sm"), {
      minWidth: "139.5px"
    }),
    btn50: {
      width: "100%",
      "&:first-child": _objectSpread({}, theme.direction === "rtl" ? {
        marginLeft: theme.spacing(2)
      } : {
        marginRight: theme.spacing(2)
      })
    },
    btnNoMargin: {
      width: "100%",
      "&:first-child": _objectSpread({}, theme.direction === "rtl" ? {
        marginLeft: 0
      } : {
        marginRight: 0
      })
    },
    bg: _defineProperty({
      width: "100%",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), \n      0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px \n      rgba(0, 0, 0, 0.08)",
      border: "1px solid ".concat(_pittaModules.LightColors.primary["5"]),
      boxSizing: "content-box",
      // 이벤트맵 프로젝트 디자인으로 borderRadius: 12 , 전체적용(Leehj)
      borderRadius: 12
    }, theme.breakpoints.up("sm"), {
      maxWidth: 560
    }),
    bgMobile: {
      margin: theme.spacing(2)
    },
    bgFullSize: {
      maxWidth: "100%",
      minHeight: "100%",
      margin: 0,
      borderRadius: 0
    },
    bgMember: _defineProperty({
      width: "100%",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), \n      0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px \n      rgba(0, 0, 0, 0.08)",
      border: "1px solid ".concat(_pittaModules.LightColors.primary["5"]),
      boxSizing: "content-box"
    }, theme.breakpoints.up("sm"), {
      maxWidth: 438
    }),
    btnWrapW100: _objectSpread(_objectSpread({
      width: "100%"
    }, theme.direction === "rtl" ? {
      marginRight: 0
    } : {
      marginLeft: 0
    }), {}, {
      flexDirection: "column-reverse",
      display: "flex",
      "&:not(:first-child)": _objectSpread({}, theme.direction === "rtl" ? {
        marginRight: 0
      } : {
        marginLeft: 0
      })
    }),
    btnW100M16: {
      width: "100%",
      marginBottom: 16
    },
    btnFullSizeSub: {
      padding: theme.spacing(0, 2, 0)
    },
    fullsizeSubBtnWrap: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      "& > button:last-child": {
        margin: theme.spacing(0, 0, 2)
      }
    },
    fullWidthBtn: {
      display: "flex",
      width: "100%",
      justifyContent: "center"
    },
    mobileBtnDiv: {
      display: "flex"
    },
    btnOrder1: {
      order: 1
    },
    btnOrder2: {
      order: 2
    },
    buttonPadding22: {
      padding: "0px 22px 24px"
    },
    noScroll: {
      height: "100vh"
    },
    mg2424: {
      padding: theme.spacing(3)
    },
    headingText: {
      display: "block",
      width: "calc(100% - 30px)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  };
});
var Modal = function Modal(props) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5, _clsx6, _clsx7, _clsx8, _clsx9;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var open = props.open,
    zIndex = props.zIndex,
    mobile = props.mobile,
    onClose = props.onClose,
    onClickAway = props.onClickAway,
    onClickNegative = props.onClickNegative,
    onClickPositive = props.onClickPositive,
    heading = props.heading,
    headingIcon = props.headingIcon,
    closeStyle = props.closeStyle,
    close = props.close,
    closeLeft = props.closeLeft,
    loading = props.loading,
    content = props.content,
    LButton = props.LButton,
    RButton = props.RButton,
    Secondary = props.Secondary,
    LButtonDisabled = props.LButtonDisabled,
    RButtonDisabled = props.RButtonDisabled,
    className = props.className,
    rootClassName = props.rootClassName,
    titleClassName = props.titleClassName,
    contentClassName = props.contentClassName,
    actionClassName = props.actionClassName,
    fullSize = props.fullSize,
    member = props.member,
    btnCenter = props.btnCenter,
    selectedNum = props.selectedNum,
    fullSizeSub = props.fullSizeSub,
    btnCenterMobile = props.btnCenterMobile,
    noPadding = props.noPadding,
    noScroll = props.noScroll,
    btnNoMargin = props.btnNoMargin,
    playVOD = props.playVOD,
    container = props.container,
    RButtonClassName = props.RButtonClassName,
    LButtonClassName = props.LButtonClassName,
    scrollPaperClassName = props.scrollPaperClassName,
    paperScrollPaperClassName = props.paperScrollPaperClassName,
    paperWidthSmClassName = props.paperWidthSmClassName,
    headerBtnClassName = props.headerBtnClassName,
    disablePortal = props.disablePortal,
    headerBtn = props.headerBtn,
    longHeader = props.longHeader,
    headingTextClassName = props.headingTextClassName,
    fullWidthBtn = props.fullWidthBtn;
  var renderBody = function renderBody() {
    if (typeof content === "string") {
      return /*#__PURE__*/_react.default.createElement(_core.DialogContentText, {
        className: classes.mg0,
        id: "alert-dialog-description"
      }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: _pittaModules.LightColors.primary["1"],
        dangerouslySetInnerHTML: {
          __html: content
        }
      }));
    } else {
      return content;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    dir: theme.direction,
    open: open,
    disablePortal: disablePortal,
    onClose: onClickAway,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    style: {
      zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : 1300
    },
    classes: {
      root: rootClassName,
      scrollPaper: scrollPaperClassName,
      paperScrollPaper: paperScrollPaperClassName,
      paperWidthSm: paperWidthSmClassName,
      paper: (0, _clsx10.default)(classes.bg, (_clsx = {}, _defineProperty(_clsx, classes.bgMobile, mobile), _defineProperty(_clsx, classes.bgFullSize, fullSize || fullSizeSub), _defineProperty(_clsx, classes.bgMember, member), _clsx), className)
    },
    container: container,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, heading !== undefined ? /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    classes: {
      root: (0, _clsx10.default)(classes.dialogTitleRoot, (_clsx2 = {}, _defineProperty(_clsx2, classes.dialogTitleFull, fullSize || fullSizeSub), _defineProperty(_clsx2, classes.dialogTitleIcon, !!headingIcon), _defineProperty(_clsx2, classes.longHeaderRoot, longHeader), _defineProperty(_clsx2, classes.dialogTitleClose, close), _clsx2), titleClassName)
    },
    disableTypography: true,
    id: "alert-dialog-title"
  }, headingIcon, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: playVOD ? "Body" : "H6",
    className: (0, _clsx10.default)(playVOD && classes.headingText, (_clsx3 = {}, _defineProperty(_clsx3, classes.headingTextIcon, !!headingIcon), _defineProperty(_clsx3, classes.longHeaderText, longHeader && mobile), _clsx3), headingTextClassName)
  }, heading)) : "", !mobile && (close || closeLeft) ? /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    className: (0, _clsx10.default)(classes.close, closeStyle, (_clsx4 = {}, _defineProperty(_clsx4, classes.closeLongHeader, longHeader), _defineProperty(_clsx4, classes.closeRight, !closeLeft), _defineProperty(_clsx4, classes.closeLeft, closeLeft), _clsx4)),
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)) : "", headerBtn && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx10.default)(classes.headerBtn, headerBtnClassName)
  }, headerBtn), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: (0, _clsx10.default)(
    // classes.mg24,
    // padding uxui프로젝트 디자인 반영
    classes.contentPadding, (_clsx5 = {}, _defineProperty(_clsx5, classes.contentFullSize, fullSize), _defineProperty(_clsx5, classes.contentFullNoBoder, fullSizeSub), _defineProperty(_clsx5, classes.noPadding, noPadding), _defineProperty(_clsx5, classes.noScroll, noScroll), _defineProperty(_clsx5, classes.mg2424, member), _defineProperty(_clsx5, classes.dialogContentIcon, !!headingIcon), _defineProperty(_clsx5, classes.longHeaderContentPadding, longHeader), _defineProperty(_clsx5, classes.longHeaderNoContentPadding, longHeader && content === ""), _clsx5), contentClassName)
  }, renderBody()), (LButton || RButton) && /*#__PURE__*/_react.default.createElement(_core.DialogActions, {
    className: (0, _clsx10.default)(classes.buttonPadding, (_clsx6 = {}, _defineProperty(_clsx6, classes.btnFullSize, fullSize), _defineProperty(_clsx6, classes.btnFullCenter, fullSize), _defineProperty(_clsx6, classes.btnCenter, btnCenter), _defineProperty(_clsx6, classes.btnFullSizeSub, fullSizeSub), _defineProperty(_clsx6, classes.buttonPadding22, btnCenterMobile), _defineProperty(_clsx6, classes.longHeaderbtnPadding, longHeader), _clsx6), actionClassName)
  }, btnCenter && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, selectedNum)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx10.default)((_clsx7 = {}, _defineProperty(_clsx7, classes.btnCenterWrap, fullSize && btnCenter), _defineProperty(_clsx7, classes.fullsizeSubBtnWrap, fullSizeSub), _defineProperty(_clsx7, classes.mobileBtnDiv, mobile), _defineProperty(_clsx7, classes.fullWidthBtn, fullWidthBtn), _clsx7))
  }, LButton && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: (0, _clsx10.default)(classes.lbutton, LButtonClassName, (_clsx8 = {}, _defineProperty(_clsx8, classes.btnNoMargin, btnCenter && fullSize && btnNoMargin), _defineProperty(_clsx8, classes.btn50, btnCenter && fullSize), _defineProperty(_clsx8, classes.btnOrder2, fullSizeSub), _defineProperty(_clsx8, classes.longHeaderLbutton, longHeader), _clsx8)),
    onClick: onClickNegative,
    color: "primary",
    variant: "outlined",
    disabled: LButtonDisabled || loading,
    fullWidth: fullSizeSub
  }, LButton), RButton && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: (0, _clsx10.default)(classes.rbutton, RButtonClassName, (_clsx9 = {}, _defineProperty(_clsx9, classes.btnNoMargin, btnCenter && fullSize && btnNoMargin), _defineProperty(_clsx9, classes.btn50, btnCenter && fullSize), _defineProperty(_clsx9, classes.btnOrder1, fullSizeSub), _defineProperty(_clsx9, classes.longHeaderRbutton, longHeader), _clsx9)),
    onClick: onClickPositive,
    color: Secondary ? "secondary" : "primary",
    disabled: RButtonDisabled,
    loading: loading,
    fullWidth: fullSizeSub
  }, RButton))));
};
exports.Modal = Modal;